/**
 * Канонічна структура розділів світу «Хроніки Альбіону» (Design Brief §8).
 * Дерево показується ЗАВЖДИ (навіть на порожній БД) — лічильники підтягуються
 * з api.wikiTree() за збігом treePath. icon = ключ з dvIcons; cat = CSS-токен кольору.
 */
export interface CatNode {
  path: string;        // treePath, відповідає /wiki/_/<path>
  label: string;       // UA назва
  icon: string;        // ключ dvIcons
  cat: string;         // CSS-змінна категорійного кольору, напр. 'cat-city'
  type?: string;       // дефолтний тип сутності для «+ Створити»
  children?: CatNode[];
}

export const CATEGORY_TREE: CatNode[] = [
  {
    path: 'World', label: 'Світ', icon: 'world', cat: 'cat-world', type: 'region',
    children: [
      { path: 'World/Regions', label: 'Регіони', icon: 'region', cat: 'cat-world', type: 'region' },
      { path: 'World/Cities', label: 'Міста й поселення', icon: 'city', cat: 'cat-city', type: 'city' },
      { path: 'World/Locations', label: 'Локації', icon: 'location', cat: 'cat-location', type: 'location' },
      { path: 'World/Maps', label: 'Мапи', icon: 'map', cat: 'cat-world', type: 'map' },
    ],
  },
  { path: 'Peoples', label: 'Народи й культури', icon: 'people', cat: 'cat-people', type: 'culture' },
  { path: 'Factions', label: 'Фракції та організації', icon: 'faction', cat: 'cat-faction', type: 'faction' },
  {
    path: 'Characters', label: 'Персонажі', icon: 'character', cat: 'cat-character', type: 'npc',
    children: [
      { path: 'Characters/PCs', label: 'Герої гравців', icon: 'ally', cat: 'cat-character', type: 'character' },
      { path: 'Characters/NPCs', label: 'NPC', icon: 'npc', cat: 'cat-character', type: 'npc' },
      { path: 'Characters/Allies', label: 'Союзники', icon: 'ally', cat: 'cat-character', type: 'ally' },
      { path: 'Characters/Bestiary', label: 'Бестіарій / Вороги', icon: 'beast', cat: 'cat-character', type: 'adversary' },
    ],
  },
  {
    path: 'Lore', label: 'Лор та історія', icon: 'lore', cat: 'cat-lore', type: 'lore',
    children: [
      { path: 'Lore/Timeline', label: 'Хронологія', icon: 'timeline', cat: 'cat-lore', type: 'event' },
      { path: 'Lore/Deities', label: 'Міфи й боги', icon: 'deity', cat: 'cat-deity', type: 'deity' },
      { path: 'Lore/Legends', label: 'Легенди', icon: 'lore', cat: 'cat-lore', type: 'lore' },
    ],
  },
  { path: 'Campaigns', label: 'Кампанії', icon: 'campaign', cat: 'cat-campaign', type: 'campaign' },
  { path: 'Quests', label: 'Квести', icon: 'quest', cat: 'cat-quest', type: 'quest' },
  { path: 'Items', label: 'Предмети та артефакти', icon: 'item', cat: 'cat-item', type: 'item' },
  { path: 'Abilities', label: 'Унікальні вміння', icon: 'ability', cat: 'cat-ability', type: 'ability' },
  { path: 'Mechanics', label: 'Механіки', icon: 'difficulty', cat: 'cat-world', type: 'mechanic' },
];
